module.exports = __webpack_public_path__ + "static/media/shared-workspace.c718e69b.svg";